'use client'

import { useSolana } from '@dewicats/connect-button'
import { Avatar, AvatarGroup, styled } from '@mui/material'
import { memo, useMemo } from 'react'

type AvatarListProps = {
  images: string[]
  total?: number
  max?: number
}

const StyledAvatarGroup = styled(AvatarGroup)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    flexWrap: 'wrap',
  },
}))

function AvatarList({ images, max, total }: AvatarListProps) {
  const { anchorProvider } = useSolana()
  const isDevnet = useMemo(() => {
    return anchorProvider?.connection.rpcEndpoint.includes('devnet')
  }, [anchorProvider])

  return (
    <StyledAvatarGroup total={total} max={max}>
      {images?.map((img) => (
        <Avatar
          key={img}
          src={`${isDevnet ? '' : 'https://img-cdn.magiceden.dev/rs:fit:640:0:0/plain/'}${img}`}
        >
          {/* {!vote.nftUri && `${vote.name.at(0)}`} */}
        </Avatar>
      ))}
    </StyledAvatarGroup>
  )
}

export default memo(AvatarList)
